import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Gamepad2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) { navigate("/"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId },
          { headers: { "X-Session-ID": sessionId } });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/profile", { state: { user: data } });
      } catch {
        navigate("/");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-4">
      <Gamepad2 className="w-10 h-10 text-neon-cyan animate-pulse" />
      <div className="flex items-center gap-2 text-zinc-400 font-mono">
        <Loader2 className="w-5 h-5 animate-spin" /> Signing you in…
      </div>
    </div>
  );
}
